





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MoreInfoModal from '@/components/MoreInfoModal.vue';
import { Getter } from 'vuex-class';
import FormProjectUserPicker from '@/components/form/FormProjectUserPicker.vue';
import type { AppliedLesson } from '@/models/appliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import FormDynamicFieldPicker from '@/components/form/FormDynamicFieldPicker.vue';
import DetailedAppliedLessonTree from './DetailedAppliedLessonTree.vue';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { CompanySetting } from '@/models/companySetting';
import type { PMSubPhase } from '@/models/pmsubphase';
import type { AppliedLessonsFilter } from '@/helpers/AppliedLessonsFilter';

interface TopicOrSubPhaseOrSubProcess {
    id: number;
    title: string;
    appliedLessons: any[];
    order?: number;
}

@Component({
    name: 'AppliedLessonTable',
    components: {
        MoreInfoModal,
        FormProjectUserPicker,
        FormDynamicFieldPicker,
        DetailedAppliedLessonTree,
    },
})
export default class AppliedLessonTable extends Vue {
    @Prop({
        required: true,
    })
    private appliedLessons;

    @Prop({
        required: true,
    })
    private tableColumns: AppliedLessonsFilter;

    @Prop({
        required: false,
    })
    private highlight: number | null;

    @Prop({
        required: false,
    })
    private type: AppliedLessonType;

    @Prop({
        required: false,
        default: () => [],
    })
    private selectedPmSubPhases: PMSubPhase[];

    @Prop({
        required: false,
    })
    private expandEverything: boolean;

    @Prop() private isUpdating: boolean;

    @Getter('utils/currentLocale') private currentLocale: string;
    @Getter('account/companySetting') private companySetting: CompanySetting;

    private isReady: boolean = false;
    private tableCollapsed: boolean = false;
    private openedDetailRows: number[] = [];
    private groupedAppliedLessons: TopicOrSubPhaseOrSubProcess[] = [];

    @Watch('appliedLessons')
    private onLoadedAppliedLessons() {
        this.init();
    }

    @Watch('selectedPmSubPhases')
    private onChangedSelectedPMSubPhases() {
        console.log('onChangedSelectedPMSubPhases');
        this.init();
    }

    private mounted() {
        if (this.groupAppliedLessonsByKey.length === 0) {
            this.init();
        }
    }

    private init() {
        this.groupedAppliedLessons = this.groupAppliedLessonsByKey();
        for (const el of this.groupedAppliedLessons) {
            this.openedDetailRows.push(el.id);
        }
        this.isReady = true;
    }

    private update(lesson: AppliedLesson | PMAppliedLesson | XAppliedLesson) {
        this.$emit('update', lesson);
    }

    private toggleUpdateAppliedLessonModal(value) {
        this.$emit('toggleUpdateAppliedLessonModal', value);
    }

    private groupAppliedLessonsByKey() {
        const appliedLessonsMap = new Map();
        const keysMap = new Map();

        this.appliedLessons.forEach((appliedLesson: any) => {
            let temp: TopicOrSubPhaseOrSubProcess | null = null;

            if (this.type === AppliedLessonType.AppliedLesson) {
                temp = appliedLesson.lesson.topics[0];
            }
            if (this.type === AppliedLessonType.PMAppliedLesson) {
                temp = appliedLesson.hasOwnProperty('lesson')
                    ? appliedLesson.lesson.sub_phase
                    : appliedLesson.pm_lesson.sub_phase;
            }

            if (this.type === AppliedLessonType.XAppliedLesson) {
                temp = appliedLesson.hasOwnProperty('lesson')
                    ? appliedLesson.lesson.x_sub_process
                    : appliedLesson.x_lesson.x_sub_process;
            }

            if (temp !== null) {
                if (!keysMap.has(temp.id)) {
                    keysMap.set(temp.id, { id: temp.id, title: temp.title, order: temp.order, appliedLessons: [] });
                }

                const pre = appliedLessonsMap.has(temp.id) ? appliedLessonsMap.get(temp.id) : [];
                appliedLessonsMap.set(temp.id, pre.concat([appliedLesson]));
            }
        });

        for (const [key, value] of appliedLessonsMap) {
            const temp: TopicOrSubPhaseOrSubProcess = keysMap.get(key);
            temp.appliedLessons = value;
            keysMap.set(temp.id, temp);
        }

        return Array.from(keysMap.values()).sort((a, b) => {
            if (a.order && b.order) {
                return a.order - b.order;
            }

            return a.title.localeCompare(b.title);
        });
    }

    get tableLabel() {
        switch (this.type) {
            case AppliedLessonType.AppliedLesson:
                return this.$i18n.tc('keywords.topic', 1).toString();
            case AppliedLessonType.PMAppliedLesson:
                return this.$i18n.tc('keywords.subPhase', 1).toString();
            case AppliedLessonType.XAppliedLesson:
                return this.currentLocale === 'en'
                    ? this.companySetting.x_en_sub_process_title
                    : this.companySetting.x_de_sub_process_title;
            default:
        }
    }

    private toggleDetailRows() {
        if (this.tableCollapsed) {
            this.openedDetailRows = this.groupedAppliedLessons.map((el) => el.id);
        } else {
            this.openedDetailRows = [];
        }
        this.tableCollapsed = !this.tableCollapsed;
    }
}
